/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

const OrderTypes = Object.freeze({
  MFD: '1',
  PRTNR: '2',
  JAPAN: '3',
  MAINT: '4',
  VB0: '6',
  GUAM_VB0: '10',
  HAWAII_VB0: '11',
  RELOCATION: '12',
  PRTNR_A3: '13',
  PRTNR_A4: '14',
  PRTNR_PROD: '15',
  WIDE: '17',
  SPECIALTY_REQ: '19',  
  CONUS: '20',
  OCONUS: '21',
  JAPAN_IDIQ: '22',
  EU_ME_1: '23',
  EU_ME_2: '24',
  EU_ME_3: '25',
  EU_ME_4: '26',
});

export default OrderTypes;
